<template>
  <div class="loading-con">
    <a-spin></a-spin>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.loading-con {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,0.2);
}
</style>